/* WorkTrigFutureViewComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
//const UserGridData = require('@gluenetworks/entity_grid_gl').UserData;
const _ = require("lodash");

const Renderer = require("./WorkTrigFutureViewRenderer");
const DateColumn = require("./column_renderers/date_column/DateComponent");
const OrderColumn = require("./column_renderers/order/OrderComponent");
const PagingWorkTrigFutureFeed = require("./PagingWorkTrigFutureFeed");

class WorkTrigFutureViewComponent extends EventEmitter {
    constructor(logger, gameEditor, userSession, storageFactory, solutionsManager) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._solutionName = (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "futureView";
        this._userGridData = storageFactory.getRemoteStorageInstanceForEntityGrid("entity_grid_gl", this._gridKey);
        this._explorerState = {
            selectedIds: []
        };

        this._entity = undefined;
        this._pagingFeed = undefined;

        this._renderer = new Renderer(this);
    }

    get columnConfig() {
        let columns = {
            expectedExecutionTime: {
                label: "Execution Time",
                columnRendererComponent: DateColumn,
                width: 175,
                priority: 1
            },
            /*status: {
                label: 'Status',
                entityColumn: 'status',
                width: 100,
                priority: 2
            },
            isFirst: {
                label: 'First Occurrence',
                entityColumn: 'isFirst',
                width: 100,
                priority: 3,
                show: false,
                editable: false
            },
            isLast: {
                label: 'Last Occurrence',
                entityColumn: 'isLast',
                width: 100,
                priority: 4,
                show: false,
                editable: false
            },*/
            order: {
                label: "Order",
                entityColumn: true,
                columnRendererComponent: OrderColumn,
                width: 100,
                priority: 5,
                show: true,
                sortable: false
            }
        };
        return columns;
    }

    get pagingFeed() {
        return this._pagingFeed;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS  */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _patchSorting(sorting) {
        let patchedSorting = _.clone(sorting);
        // add second sorting order by execution time
        if (sorting && Object.keys(sorting).length === 1 && !sorting.expectedExecutionTime) {
            patchedSorting.expectedExecutionTime = 1;
        }
        return patchedSorting;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    whenModelIsReady() {
        return this._gameEditor.whenTriggerTypeIsReady().then(() => {
            const userSorting = this._userGridData.getSorting() || {};
            const patchedSorting = this._patchSorting(userSorting);
            this._entity = this._gameEditor.getTriggerType();
            this._pagingFeed = new PagingWorkTrigFutureFeed({
                feedKey: this._gridKey + "_feed",
                userSession: this._userSession,
                entityDef: this._gameEditor.getTriggerType(),
                columnConfig: this.columnConfig,
                pageSize: 100,
                sort: patchedSorting,
                additionalDataFields: ["isFirst", "isLast"]
            });
            this._registerListeners();
            return this.whenFeedReady();
        });
    }

    wasFeedPreviouslyInitialized() {
        return this._pagingFeed.wasPreviouslyInitialized();
    }

    whenFeedReady() {
        return this._pagingFeed.whenFeedReady();
    }

    get renderer() {
        return this._renderer;
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        let shutdowns = [this._renderer.shutdown(), this._pagingFeed.shutdown()];
        return Promise.all(shutdowns).then(
            () => {
                this._unregisterListeners();
                this._logger = undefined;
                this._gameEditor = undefined;
                this._userSession = undefined;
                this._renderer = undefined;
                this._gridKey = undefined;
                this._userGridData = undefined;
                this._entity = undefined;
                this._pagingFeed = undefined;
                this._explorerState = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "WorkTrigFutureViewComponent.shutdown() error");
            }
        );
    }

    get explorerState() {
        return this._explorerState;
    }

    set explorerState(val) {
        this.setExplorerState(val);
    }

    setExplorerState(val) {
        this._explorerState = val;
    }

    updateExplorerState(property, val) {
        _.set(this._explorerState, property, val);
    }

    setSort(sortData) {
        let sort = {};
        sort[sortData.sortColumn] = sortData.sort === "asc" ? 1 : -1;
        this._patchSorting(sort);
        this._pagingFeed.setSort(sort);
    }

    resetSelection() {
        let selectedIds = this.getSelectedFutureIds().selectedRows;
        if (!selectedIds || !selectedIds.length) {
            return;
        }

        selectedIds.splice(0, selectedIds.length);
        this.updateExplorerState("selectedIds", { selectedRows: selectedIds });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/
    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    getSelectedFutureIds() {
        if (!this._explorerState || !this._explorerState.selectedIds) {
            return [];
        }
        return this._explorerState.selectedIds;
    }

    getFutureById(id) {
        return this._pagingFeed.getEntityById(id);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = WorkTrigFutureViewComponent;

WorkTrigFutureViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.storageFactory",
    "$teve.solutionsManager"
];

WorkTrigFutureViewComponent.$displayDetails = {
    type: "View",
    name: "Future Occurrences",
    icon: "worktrigger.future",
    shown: true,
    title: "Future Occurrences",
    order: 3
};
